
export const languages ={
    com:"en",
    fr:"fr",
    be:"be",
    es:"es",
}

// Default Language
export const DEFAULT_LANGUAGE = 'fr';